module.exports = __webpack_public_path__ + "static/media/nav_card_icon_4.f01efc89.svg";